import "../../styles/legal/terms.css";

const Terms = () => {
  return (
    <section className="terms-page">
      <h1>Terms of Service</h1>

      <p className="updated">Last updated: January 2026</p>

      <div className="terms-section">
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using VisualLab, you agree to be bound by these Terms
          of Service. If you do not agree, please do not use the platform.
        </p>
      </div>

      <div className="terms-section">
        <h2>2. Platform Overview</h2>
        <p>
          VisualLab is an educational platform that allows users to create,
          publish, and explore visualizations and animations for learning
          purposes.
        </p>
      </div>

      <div className="terms-section">
        <h2>3. User Accounts</h2>
        <ul>
          <li>You must provide accurate and complete information</li>
          <li>You are responsible for maintaining account security</li>
          <li>You are responsible for all activity under your account</li>
        </ul>
      </div>

      <div className="terms-section">
        <h2>4. User Content</h2>
        <p>
          You retain ownership of the content you create. By publishing content
          on VisualLab, you grant us the right to display and distribute it
          within the platform.
        </p>
        <p>
          You are responsible for ensuring that your content does not violate
          any laws or third-party rights.
        </p>
      </div>

      <div className="terms-section">
        <h2>5. Prohibited Activities</h2>
        <ul>
          <li>Uploading harmful, illegal, or misleading content</li>
          <li>Attempting to exploit or disrupt the platform</li>
          <li>Unauthorized access to other users’ data</li>
        </ul>
      </div>

      <div className="terms-section">
        <h2>6. Account Suspension</h2>
        <p>
          We reserve the right to suspend or restrict accounts that violate
          these terms or misuse the platform.
        </p>
      </div>

      <div className="terms-section">
        <h2>7. Limitation of Liability</h2>
        <p>
          VisualLab is provided “as is”. We do not guarantee uninterrupted or
          error-free service and are not liable for any damages arising from
          platform usage.
        </p>
      </div>

      <div className="terms-section">
        <h2>8. Changes to Terms</h2>
        <p>
          We may update these Terms from time to time. Continued use of the
          platform indicates acceptance of the updated terms.
        </p>
      </div>

      <div className="terms-section">
        <h2>9. Contact</h2>
        <p>
          For questions regarding these Terms, please reach out through the
          feedback section or the contact information provided on the platform.
        </p>
      </div>
    </section>
  );
};

export default Terms;
